var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCuttingRectangular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "45px",
    viewBox: "0 0 78 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.363158315 78 0.363158315 78 14.7848731 78 45.3631583 0 45.3631583"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 78,
    height: 45,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "designer/editor-rect-canvas-copy",
    transform: "translate(-29.000000, -915.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cutting",
    transform: "translate(20.000000, 871.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rechteckig",
    transform: "translate(2.000000, 32.636842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(7.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-6",
    stroke: "#636363",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    fill: "#FFFFFF",
    strokeDasharray: 5,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pretzel",
    transform: "translate(40.000000, 13.363158)",
    fillRule: "nonzero",
    fill: "#4990E2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2280678,4.56292308 C28.731661,2.41446154 26.4770169,0.942846154 24.1974237,0.627846154 C24.0753898,0.611153846 23.9387119,0.589615385 23.7895593,0.566461538 C23.1647458,0.469 22.3094237,0.336 21.3700339,0.336 C19.5709831,0.336 18.0973559,0.841615385 16.9719322,1.85715385 L16.2191186,2.60453846 L15.8177627,2.30730769 C14.4466441,1.29015385 12.8862373,0.648846154 11.3057627,0.452307692 C10.2573559,0.322538462 9.35647458,0.366153846 7.85735593,0.631076923 C3.23145763,1.44953846 0,5.21015385 0,9.77684615 C0,12.1843077 0.823322034,14.5255385 2.32732203,16.422 L1.6059661,17.1403077 C0.816271186,17.9393846 0.817898305,19.2295385 1.63905085,20.0447692 C2.02359322,20.4265385 2.53450847,20.6370769 3.07742373,20.6370769 C3.62738983,20.6370769 4.14372881,20.4216923 4.52610169,20.034 L5.46061017,19.11 C7.10671186,20.0512308 8.96,20.5466154 10.848,20.5466154 L20.6692881,20.5466154 C22.839322,20.5466154 24.9399322,19.9413846 26.779661,18.8057692 L28.0195254,20.0366923 C28.4105763,20.4173846 28.9252881,20.6273846 29.4698305,20.6273846 C30.016,20.6273846 30.5296271,20.4157692 30.9445424,20.0043846 C31.3317966,19.6199231 31.5438644,19.1089231 31.5416949,18.5661538 C31.5389831,18.0239231 31.3214915,17.5150769 30.9331525,17.1370769 L29.8359322,16.0477692 C30.7655593,14.8265385 31.4088136,13.4642308 31.7445424,11.9899231 C32.3259661,9.43923077 31.7873898,6.80184615 30.2280678,4.56292308 Z M5.42698305,13.3193846 C4.85477966,12.4826154 4.49627119,11.529 4.38237288,10.5290769 C4.36338983,10.3621538 4.35037288,10.1963077 4.34386441,10.0326154 C4.27010169,8.14423077 5.10481356,6.87076923 5.8180339,6.13469231 C6.88922034,5.02923077 8.39647458,4.39546154 9.95416949,4.39546154 C11.1658305,4.39546154 12.3140339,4.77992308 13.2930169,5.51061538 L5.42698305,13.3193846 Z M19.5254237,16.7768462 L12.4745763,16.7768462 C10.3387119,16.7768462 9.44542373,16.3250769 8.69586441,15.9050769 L16.2722712,8.37415385 L23.6745763,15.7225385 C22.7292203,16.2480769 21.5940339,16.7768462 19.5254237,16.7768462 Z M19.1918644,5.47992308 C20.2245424,4.52792308 21.3711186,4.30876923 22.1895593,4.30876923 C23.6013559,4.30876923 25.0684746,4.95169231 26.1141695,6.02915385 C27.1642034,7.11092308 27.7114576,8.52815385 27.6555932,10.0207692 C27.6496271,10.1893077 27.6366102,10.3583846 27.6170847,10.5290769 C27.5183729,11.3954615 27.2195254,12.2343846 26.7617627,12.9957692 L19.1918644,5.47992308 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Aa",
    fontFamily: "Arial-BoldMT, Arial",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#F6A623"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 30.3631583
  }, "Aa")))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuttingRectangular);
export default __webpack_public_path__ + "static/media/cutting-rectangular.be98ec0b90211f7b8480984fc4b51907.svg";
export { ForwardRef as ReactComponent };